// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bc89c274","455":"a1a277e9","488":"8aa53ebc"}[chunkId] + ".chunk.js";
};